/**
 * internal dependencies
 */
import { DASHBOARD_CONTAINER, PAGE_LOADER } from '../../../../types/types';
import { getParameters } from '../../../../helpers/helpers';

import { VEHICLE_POOL_FORM, COMMON_FORM_ELEMENTS, VEHICLE_ASK_FOR_ID } from "./utils/pin-pool-types";
import { displayInfo } from './utils/display-info';
import { pinPoolTable } from './utils/display-pinpool-table';

import GetCardGroupVehiclePin from '../../../../routes/get-vehicle-pins';
import { usePinPool } from './utils/use-pin-pool';
import { addPinPool } from './add/add-pin-pool';

import ExportCsv from '../csv/export-csv';

/**
 * Handles the Vehicle Pin Pool functionality for the Individual Card Group.
 * 
 * @returns void
 */
const HandleVehiclePinPool = async () => {
  const groupID = getParameters('cardGroupID');
  if (!groupID) return;

  try {
    const response = await GetCardGroupVehiclePin(groupID);
    const { pinPool: { hasPinPool, pins }, cardGroup } = response.body;
    const { vpActive, } = VEHICLE_POOL_FORM;
    const { ceExport, ceOptional } = COMMON_FORM_ELEMENTS;

    displayInfo(cardGroup);

    if ( hasPinPool ) {
      vpActive.checked = true;
      usePinPool(vpActive, response, VEHICLE_ASK_FOR_ID);
      pinPoolTable(pins, VEHICLE_ASK_FOR_ID);
      ceExport.classList.remove('aafp_pin-disabled');
    }

    if ( !hasPinPool && pins.length > 0 ) {
      usePinPool(vpActive, response, VEHICLE_ASK_FOR_ID);
      pinPoolTable(pins, VEHICLE_ASK_FOR_ID);
      ceOptional.forEach(field => {
        field.classList.add('aafp_pin-disabled');
      });
    }

    addPinPool(response, VEHICLE_ASK_FOR_ID);

    vpActive.addEventListener('click', () => usePinPool(vpActive, response, VEHICLE_ASK_FOR_ID));

    ceExport.addEventListener('click', () => {
      ceExport.classList.add('aafp_button-loading');
      ExportCsv(response, 'vehicle_pin');
    });
  } catch (error) {
    console.error('Error fetching Vehicle Pin Pool data:', error);
  } finally {
    PAGE_LOADER.loaderContainer.classList.add('aafp_no-show');
    DASHBOARD_CONTAINER.removeAttribute('style');
  }
};

export default HandleVehiclePinPool;